import { render, staticRenderFns } from "./view-desktop.svg?vue&type=template&id=20df9930"
var script = {}


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports